



























































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { UniteYMDHms } from '@/filters/index';
import { get, post } from '@/unite/api';
import { exportExcel } from '@/unite/exportExcel';
import moment from 'moment';
// @ts-ignore
import jsZip from 'jszip';
// @ts-ignore
import { saveAs } from 'file-saver';

const t = new Date()
  .valueOf()
  .toString()
  .substr(0, 10);
@Component({
  components: {},
  filters: { UniteYMDHms }
})
export default class SearchPaginationTable extends Vue {
  downExcel: any = new exportExcel();
  @Prop() pageData: any;
  @Prop() downData: any;
  @Prop() checkOption: any;
  data: any[] = [];
  dataDown: any[] = [];
  multipleSelection: any[] = [];
  current: any = 0;
  pageSizeArr: any[] = [10, 20, 40, 100];
  showTime: any = moment(new Date()).format('YYYY-MM-DD 00:00:00') +
    ' 至 ' +
    moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  pageSize: any = 10;
  countData: number = 0;
  loading: boolean = false;
  downLoading: boolean = false;
  pickerOptions: any = {
    shortcuts: [
      {
        text: '今天',
        onClick(picker: any) {
          picker.$emit('pick', new Date());
        }
      },
      {
        text: '昨天',
        onClick(picker: any) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      },
      {
        text: '一周前',
        onClick(picker: any) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }
    ]
  };
  created() {
    this.getData();
  }
  // todo 获取列表数据
  getData() {
    // @ts-ignore
    this.pageData.searchData.forEach(item => {
      if (item['type'] === 'time') {
        // @ts-ignore
        item.model.forEach(d => {
          this.pageData.info[d.value] = this.pageData.info[d.value]
            ? moment(this.pageData.info[d.value]).format(d.format)
            : '';
        });
      }
    });
    this.loading = true;
    post(this.pageData.url, this.pageData.info)
      .then(d => {
        // if (this.pageData.amounts) {
        //   //@ts-ignore
        //   this.pageData.amounts.sum_amount = d['data']['sum_amount'];
        // }
        // @ts-ignore
        this.data = d.data.Data;
        if (typeof this.data === 'string') {
          this.data = JSON.parse(this.data);
        }
        // @ts-ignore
        if (this.pageData.isPagination) {
          this.countData = Number(d.data.count_data);
        }
        this.data.forEach(item1 => {
          // @ts-ignore
          this.pageData.tableData.header.forEach(item2 => {
            if (item2.status) {
              // //console.log(item1)
              item1[item2.prop] = item2.status[item1[item2._prop]];
            }
          });
        });
        this.loading = false;
      })
      .catch(e => {
        this.loading = false;
      });
  }
  // todo 操作
  // 搜索
  private search() {
    if (this.pageData.isPagination) {
      if (this.pageData.info.page_size) {
        this.pageData.info.page_no = 1;
        this.pageSize = this.pageData.info.page_size;
        this.current = 1;
      }
    }
    Object.keys(this.pageData.info).map(item => {
      if (typeof this.pageData.info[item] === 'string') {
        this.pageData.info[item] = this.pageData.info[item].trim();
      }
    });
    if (this.pageData.amounts) {
      let trade_start = '';
      let trade_end = '';
      trade_start = this.pageData.info[this.pageData.amounts.time.start]
        ? moment(this.pageData.info[this.pageData.amounts.time.start]).format(
            'YYYY-MM-DD HH:mm:ss'
          )
        : moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      trade_end = this.pageData.info[this.pageData.amounts.time.end]
        ? moment(this.pageData.info[this.pageData.amounts.time.end]).format(
            'YYYY-MM-DD HH:mm:ss'
          )
        : moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      this.showTime = trade_start + ' 至 ' + trade_end;
    }
    this.getData();
  }
  // 下载
  downGet() {
    //alert(2);
    let info = { ...this.pageData.info };
    let pageSize = this.pageData.info.page_size;
    if (this.pageData.isPagination) {
      info.page_size = 1000000;
    }

    this.loading = true;
    post(this.pageData.url, info)
      .then(d => {
        // @ts-ignore
        this.dataDown = d.data.Data;
        // this.pageData.info.page_size = pageSize;
        this.dataDown.forEach(item1 => {
          // @ts-ignore
          this.pageData.tableData.header.forEach(item2 => {
            if (item2.status) {
              // //console.log(item1)
              item1[item2.prop] = item2.status[item1[item2._prop]];
            }
            if (item2.type == 'time') {
              item1[item2.prop] = moment(item1[item2.prop]).format(
                'YYYY-MM-DD HH:mm:ss'
              );
            }
          });
        });
        let obj = {};
        // @ts-ignore
        this.pageData.tableData.header.forEach(item => {
          // @ts-ignore
          obj[item.prop] = item.label;
        });
        // //console.log(new exportExcel())
        // @ts-ignore
        this.downExcel.exportTable(obj, this.dataDown, this.$route.name);
        // //console.log(this.data)
        this.loading = false;
        // //console.log(this.data)
      })
      .catch(e => {
        this.pageData.info.page_size = pageSize;
        this.loading = false;
      });
  }
  public btnClick(methods: string) {
    if (methods === 'refesh') {
      this.getData();
    } else if (methods === 'downAll') {
      //alert(1);
      // 导出所有
      this.downGet();
      // downHeader
    } else if (methods === 'downCheck') {
      // 导出选中
      if (!this.multipleSelection.length) {
        this.$message({
          type: 'warning',
          message: '请勾选要导出的数据!'
        });
        return;
      }
      this.downExcel.exportTable(
        this.downData.header,
        this.multipleSelection,
        this.downData.title
      );
    } else {
      this.$emit('btnClick', methods);
    }
  }
  // 操作事件
  public handleClick(methods: string, row: any) {
    this.$emit('handleClick', methods, row);
  }
  // todo 分页触发事件
  handleCurrentChange(val: number) {
    this.current = val;
    this.pageData.info.page_no = val;
    this.getData();
  }
  handleSizeChange(val: number) {
    this.pageSize = val;
    //console.log(this.pageData.info);
    this.pageData.info.page_size = val;
    this.getData();
  }
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  destroyed() {
    if (this.pageData.isPagination) {
      this.pageData.info.page_no = 1;
    }
  }
}
